import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { Storage } from "@ionic/storage";
import { ServiceProvider } from "./../../providers/service/service";
import { TranslateService } from "@ngx-translate/core";
import { RequestOptions, Headers, Http } from "@angular/http";
import { ShopperBuySocialPage } from "./../shopper-buy-social/shopper-buy-social";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
} from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-shopper-buy-social-plazalist",
  templateUrl: "shopper-buy-social-plazalist.html",
})
export class ShopperBuySocialPlazalistPage {
  lists: any;
  social_mission = "";
  social_group = "";
  url: any;
  budget: any;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {
    this.social_mission = this.navParams.data.social_mission;
    this.social_group = this.navParams.data.social_group;
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      var link = this.services.URLPlazaList;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.lists = data;
            loader.dismiss();
          },
          (error) => {
            var response = JSON.parse(error._body);
            loader.dismiss();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );

      this.storage.get("info").then((info) => {
        if (info.role == 1) {
          this.url = this.services.URLPlazaStatBudgets;
        } else if (info.role == 2) {
          this.url = this.services.URLMerchantStatBudgets;
        } else if (info.role == 3) {
          this.url = this.services.URLShopperStatBudgets;
        }
        var link = this.url;

        this.http
          .get(link, requestOptions)
          .map((res) => res.json())
          .subscribe(
            (data) => {
              this.budget = this.services.currencyFormat(data.available);
            },
            (error) => {
              // console.log(error);
              this.services.presentToastInternet();
            }
          );
      });
    });
  }

  select(id) {
    this.navCtrl.push(ShopperBuySocialPage, {
      plaza_id: id,
      social_mission: this.social_mission,
      social_group: this.social_group,
    });
  }

  backPage() {
    this.navCtrl.pop();
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-buy-social-plazalist/shopper-buy-social-plazalist.ts